import { createRef as t, Component as e } from "react";

var n = function n(t, e) {
  return e > 0 ? function (t, e, n) {
    return void 0 === e && (e = 250), function () {
      for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
        o[i] = arguments[i];
      }

      return clearTimeout(n, n = setTimeout.apply(void 0, [t, e].concat(o)));
    };
  }(t, e) : t;
},
    r = function (e) {
  var r, o;

  function i() {
    for (var r, o = arguments.length, i = new Array(o), u = 0; u < o; u++) {
      i[u] = arguments[u];
    }

    return (r = e.call.apply(e, [this].concat(i)) || this).container = t(), r.areTargetsOutside = function (t) {
      var e = [r.container].concat(r.props.refs);
      return !(!function (t) {
        return t instanceof HTMLElement || t instanceof HTMLDocument;
      }(t) || !document.contains(t)) && function (t) {
        return t.filter(function (t) {
          return t.current && t.current instanceof HTMLElement;
        });
      }(e).every(function (e) {
        return function (t, e) {
          return !1 === t.current.contains(e);
        }(e, t);
      });
    }, r.handleClickOutside = function (t) {
      r.props.onClickOutside && r.areTargetsOutside(t.target) && r.props.onClickOutside(t);
    }, r.handleMoveOutside = n(function (t) {
      r.props.onMoveOutside && r.areTargetsOutside(t.target) && r.props.onMoveOutside(t);
    }, r.props.delay), r;
  }

  o = e, (r = i).prototype = Object.create(o.prototype), r.prototype.constructor = r, r.__proto__ = o;
  var u = i.prototype;
  return u.componentDidMount = function () {
    this.props.onClickOutside && document.addEventListener("click", this.handleClickOutside, !0), this.props.onMoveOutside && document.addEventListener("mousemove", this.handleMoveOutside, !0);
  }, u.componentWillUnmount = function () {
    document.removeEventListener("click", this.handleClickOutside, !0), document.removeEventListener("mousemove", this.handleMoveOutside, !0);
  }, u.render = function () {
    return this.props.children(this.container);
  }, i;
}(e);

r.defaultProps = {
  delay: 0,
  refs: []
};
export default r;